import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import About_Us from "../views/About_Us.vue";
import Machinery from "../views/Machinery.vue";
import Contact_Us from "../views/Contact_Us.vue";
import ZM10AA from "../views/machinery/ZM10AA.vue";
import ZM02AA from "../views/machinery/ZM02AA.vue";
import CN_NC_L30 from "../views/machinery/CN_NC_L30.vue";
import ADJ_1 from "../views/machinery/AssembleMachine/ADJ_1.vue";
import CN_OA from "../views/machinery/AssembleMachine/CN_OA.vue";
import AssembleMachine from "../views/machinery/AssembleMachine.vue";
import ScrewWasherNut from "../views/machinery/AssembleMachine/ScrewWasherNut.vue";
import SWN_V from "../views/machinery/AssembleMachine/ScrewWasherNut/SWN_V.vue";
import ZM08BA from "../views/machinery/AssembleMachine/ScrewWasherNut/ZM08BA.vue";
import CN_DR from "../views/machinery/CN_DR.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: 'HOME'
    },
  },
  {
    path: "/about_us",
    name: "About_Us",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: About_Us,
  },
  {
    path: "/machinery",
    name: "Machinery",
    component: Machinery,
  },
  {
    path: "/contact_us",
    name: "Contact_Us",
    component: Contact_Us,
  },
  {
    path: "/machinery/zm02AA",
    name: "ZM02AA",
    component: ZM02AA,
  },
  {
    path: "/machinery/zm10AA",
    name: "ZM10AA",
    component: ZM10AA,
  },
  {
    path: "/machinery/cn_nc_l30",
    name: "CN_NC_l30",
    component: CN_NC_L30,
  },
  {
    path: "/machinery/AssembleMachine/adj_1",
    name: "ADJ_1",
    component: ADJ_1,
  },
  {
    path: "/machinery/AssembleMachine/cn_oa",
    name: "CN_OA",
    component: CN_OA,
  },
  {
    path: "/machinery/assemblemachine",
    name: "AssembleMachine",
    component: AssembleMachine,
  },
  {
    path: "/machinery/AssembleMachine/screwwashernut",
    name: "ScrewWasherNut",
    component: ScrewWasherNut,
  },
  {
    path: "/machinery/AssembleMachine/ScrewWasherNut/swn_v",
    name: "SWN_V",
    component: SWN_V,
  },
  {
    path: "/machinery/AssembleMachine/ScrewWasherNut/zm08ba",
    name: "ZM08BA",
    component: ZM08BA,
  },
  {
    path: "/machinery/cn_dr",
    name: "CN_DR",
    component: CN_DR,
  },
];

const router = createRouter({
  history:  createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.name == 'Home') document.title = 'HOME'
  else if (to.name == 'About_Us') document.title = 'ABOUT US'
  else if (to.name == 'Contact_Us') document.title = 'CONTACT US'
  else document.title = 'MACHINERY'

  document.title += ' | YUFA TECHNOLOGY INDUSTRY CO., LTD. 宇發科技工業股份有限公司'

  next()
})
export default router;
